import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Funnel.scss';
import { useEffect, useState, useRef } from 'react';
import BackIcon from '@/assets/rewise/back-icon.svg';
import { getFunnelList, useGetFunnelDetails, useGetFunnelList } from '../api/getFunnel';
import { Funnel } from '../types/indes';
import ArrowIcon from '@/assets/steam/arrow-r.svg';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import { ReactComponent as ArchiveFunnel } from '@/assets/steam/archive.svg';
import Edit from '@/assets/steam/edit.svg';
import { ReactComponent as AddFunnelIcon } from '@/assets/steam/add-funnel-icon.svg';
import { ReactComponent as SearchIconn } from '@/assets/steam/search-grey.svg';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import FunnelList from '../components/FunnelList';
import FunnelView from '../components/funnelView';
import HistoryView from '../components/historyView';
import { useGetDeals } from '../api/getTotalDeals';
import EditFunnel from '../components/editFunel';
import AddFunnel from '../components/addNewFunnel';
import { useArchiveFunnel, useArchiveMutipleFunnel } from '../api/archiveFunnel';
import { FunnelFilterMenu } from '@/components/Elements/FunnelFilterMenu';
import { useGetUserRoleList } from '@/features/users/api/getRefrences';
import { UserRole } from '@/features/users/types/indes';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { User } from '@/types';
import { useGetProductList } from '@/features/product/api/getProduct';
import { Product } from '@/features/product/types/indes';
import SortAsc from '@/assets/steam/sort-asc.svg';
import SortDesc from '@/assets/steam/sort-desc.svg';
import DeleteConfirmation from '@/components/DeleteConfirmation/DeleteConfirmation';

export const Funnels = () => {
  const [funneltList, setFunnelList] = useState<Funnel[]>([]);
  const [isAddNewFunnel, setIsAddNewFunnel] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [isEditFunnel, setEditFunnel] = useState(false)
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<Funnel[]>([]);
  const [selectedFunnel, setselectedFunnel] = useState<Funnel>();
  const [dealsData, setDealsData] = useState<any>();
  const useGetFunnelMutation = useGetFunnelList();
  const useGetFunnelDetailsMutation = useGetFunnelDetails();
  const useGetDealsMutation = useGetDeals();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [addNewFunnel, setAddNewFunnel] = useState(false);
  const useArchiveFunnelMutation = useArchiveFunnel();
  const useArchiveMutipleFunnelMutation = useArchiveMutipleFunnel();
  const useGetUserRoleMutation = useGetUserRoleList();
  const useGetUsersMutation = useGetUsersList();
  const [usersList, setUsersList] = useState<User[]>([]);
  const useGetProductsMutation = useGetProductList();
  const [isFetching, setIsFetching] = useState(false);
  const [productList, setProductList] = useState<Product[]>([]);
  const [pageIndex, setPageIndex] = useState(1);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [filters, setFilters] = useState<any>({});
  const [isSoretedAsc, setIsSoretedAsc] = useState(false);
  const [isArchivedFunnels, setIsArchivedFunnels] = useState(false);
  const [archivedFunnelIds, setArchivedFunnelIds] = useState<any>([]);
  const [isArchivedConfirmation, setIsArchivedConfirmation] = useState(false);
  const [archivedUsersList, setArchivedUsersList] = useState<any>([]);


  const resetState = () => {
    setProductList([]);
    setPageIndex(1);
    setTotalPages(0);
    setIsFetching(false);
  };

  // Fetch data whenever selectedTab changes
  useEffect(() => {
    resetState();
    resetScrollPosition();
    getFunnelstList(1, true);
    getTotalDeals();
    getProductList();
    getUserRoleList();
    getUsersList(1);
  }, [selectedTab, searchString]);

  const handleFilters = (filter: any) => {
    resetState();
    resetScrollPosition();
    setFilters(filter || {});
    const setReset = filter === null ? true : null;
    getFunnelstList(1, true, filter, null, setReset);
    getTotalDeals(filter, setReset);
  };

  const getFunnelstList = async (pageIndex: number, reset = false, filter?: any, selectedFunnelId?: any, resetFilters?: any) => {
    if (isFetching) return;
    setIsFetching(true);
    const res = await useGetFunnelMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter: resetFilters ? null : filter || filters,
      isArchived: selectedTab === 0 ? false : true,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if (res && res.list && res.list.length > 0 && pageIndex == 1) {
      getFunnelDetails(selectedFunnelId ? selectedFunnelId : res.list[0].id)
    }
    if (reset) {
      setFunnelList(res.list);
      setTableCurrentIndex(1);
    } else {
      setFunnelList(funneltList.concat(res.list));
      setTableCurrentIndex(pageIndex);
    }
    setIsFetching(false);
  };

  const resetScrollPosition = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleScroll = async () => {
    if (!scrollRef.current || isFetching || pageIndex >= totalPages) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      const nextPage = pageIndex + 1;
      setPageIndex(nextPage);
      await getFunnelstList(nextPage, false);
    }
  };


  const getTotalDeals = async (filter?: any, resetFilters?: any) => {
    const res = await useGetDealsMutation.mutateAsync({
      filter: resetFilters ? null : filter || filters,
    });
    if (res) {
      setDealsData(res?.details)
    }

  }

  const getUsersList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: 500,
      search: '',
      filter: { 'rolesId': [1, 2, 3, 4] },
    });
    setUsersList(res.list);

  };


  const getProductList = async () => {
    const res = await useGetProductsMutation.mutateAsync({
      page: 1,
      perPage: 100,
      search: '',
      filter: '',
    });
    setProductList(res.list);

  };

  const getFunnelDetails = async (id: any) => {
    const res = await useGetFunnelDetailsMutation.mutateAsync({
      id: Number(id)
    });

    if (res) {
      setEditFunnel(false)
      setselectedFunnel(res?.details)
    }
  }

  const onClickArchiveFunnel = async (funnelId: any) => {
    const res = await useArchiveFunnelMutation.mutateAsync({
      id: funnelId
    });
    if (res) {
      getFunnelstList(1, true);
      getTotalDeals();
    }
  }

  const getUserRoleList = async () => {
    const res = await useGetUserRoleMutation.mutateAsync({
      search: ''
    });
    if (res) {
      const filteredRoles = res.list.filter((item: any) => {
        const id = Number(item.id);
        return id !== 1 && id !== 5 && id !== 6;
      });
      setRoles(filteredRoles);

    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchString(e.target.value);
    // if(e.target.value === null || e.target.value === ''){
    //   setFunnelList([]);
    // //  setFilteredList([]);
    //   setSearchString('');
    //   getFunnelstList(1, true);
    // }else{
    //   const searchString = e.target.value;
    //   setSearchString(searchString);
    //   const res = await useGetFunnelMutation.mutateAsync({
    //     page: 1,
    //     perPage: perPage,
    //     search: searchString,
    //     filter: filters,
    //     isArchived: selectedTab === 0 ? false : true,
    //   });
  
    //   setTotalPages(res.totalPages);
    //   setTotalRecords(res.total);
    //   if (res && res.list && res.list.length > 0) {
    //     getFunnelDetails(res.list[0].id)
    //   }
    //   setFunnelList(res.list);
    //   setTableCurrentIndex(1);
    //   if (searchString) {
    //     setFilteredList(res.list);
    //   }
    // }
   
  }
    ;

  const actualList = filteredList.length ? filteredList : funneltList;

  const addToArchive = (funnelId?: any) => {
    setArchivedFunnelIds((prev: any) =>
      prev.includes(funnelId)
        ? prev.filter((id: any) => id !== funnelId)
        : [...prev, funnelId]
    );
  }


  const onClickArchiveMultipleFunnel = async (userIds?:any) => {
    const res = await useArchiveMutipleFunnelMutation.mutateAsync({
      funnelIds: archivedFunnelIds,
      userIds: userIds
    });
    if (res) {
      getFunnelstList(1, true);
      getTotalDeals();
      setIsArchivedConfirmation(false);
      setArchivedFunnelIds([])
      setArchivedUsersList([])
      setIsArchivedFunnels(false)
    }
  }


  const onConfirm = (userIds?:any) => {
    onClickArchiveMultipleFunnel(userIds)
   
  }

  const onClose = () => {
    setIsArchivedConfirmation(false);
  }

  const getUsersListForArchiveFunnels = () => {
    const getUserIdsForArchivedFunnels = funneltList && funneltList.length > 0 && funneltList?.filter((item: any) =>
      archivedFunnelIds?.includes(item?.id)
    );
    const userIds =
      getUserIdsForArchivedFunnels && getUserIdsForArchivedFunnels?.map((item: any) => item?.assignedTo) || [];


    const userListDetails = usersList?.filter((user: any) =>
      userIds.includes(user.id)
    );

    setArchivedUsersList(userListDetails)

    console.log("User Details Array:", userListDetails);
  };


  const resetArchived= () =>{
    setIsArchivedConfirmation(false);
    setArchivedFunnelIds([])
    setArchivedUsersList([])
    setIsArchivedFunnels(false)
  }
  const getStatuss = () => {
    if (archivedFunnelIds && archivedFunnelIds.length === 0 && isArchivedFunnels) {
        return 'is-cancel';
    }else if (archivedFunnelIds && archivedFunnelIds.length > 0 && isArchivedFunnels){

      return 'set-widthhh';
    }  else if (selectedTab === 1) {
      return 'remove-width';
    }
    return ''; 
  };
  


  return (
    <>

      <div className="funnel-container">

        <div className='funnel-list-container'>

          <div className='funnel-fixed-height'>
            <div className='header-funnel'>
              Funnel List
              <div className='funnel-filters'>
                {/* <SearchIconn /> */}


                <FunnelFilterMenu roles={roles} usersList={usersList} options={[]} onRoleSelect={(filter) => handleFilters(filter)}
                  showRoleFilter={false} />
              </div>
            </div>
            <div className='search-container'>
              <div className='search-filter-container'>

                <span className="search-content">
                  <SearchIcon />
                  <input
                    type="text"
                    id="simple-search"
                    placeholder="Search by Institute name"
                    onChange={searchUser}
                    className="steam-search"
                  />
                </span>
              </div>

            </div>
            <div className='funnel-tab-selection'>
              <div className={`tab-value ${selectedTab === 0 ? 'is-selected' : ''}`} onClick={() => { setSelectedTab(0);   resetArchived();
      }}>
                Current
              </div>
              <div className={`tab-value ${selectedTab === 1 ? 'is-selected' : ''}`} onClick={() => { setSelectedTab(1);  resetArchived();
    }}>
                {/* {`Archived (${dealsData?.archivedFunnelsCount})`} */}
                {`Archived`}
              </div>

            </div>

            <div className='funnel-cumulative-details'>
              <div className={`total-span`}>
                Total <span>{dealsData?.activeFunnelsCount}</span>
              </div>
              <div className={`total-amount`}>
                Cumulative deal
                <span>{Utils.convertDealSize(Number(dealsData?.totalDealSize))}</span>
              </div>

            </div>
          </div>


          <div className={`add-funnel-icon ${getStatuss()}`}>
            {isArchivedFunnels ? <><button
              className={`steam-button button-dark display-flex ${archivedFunnelIds && archivedFunnelIds.length>0 ? '' : 'set-widthhh'}`}
              onClick={() => { setIsArchivedFunnels(false); setArchivedFunnelIds([]) }} >
              <span>Cancel</span>
            </button>
             {archivedFunnelIds && archivedFunnelIds.length>0 &&<button
                className={`steam-button button-dark display-flex is-cancel`}
                onClick={() => { setIsArchivedConfirmation(true); getUsersListForArchiveFunnels() }} >
                <span>Archive</span>
              </button>}
              </> : <> {selectedTab === 0 &&<ArchiveFunnel onClick={() => { setIsArchivedFunnels(true) }} />} </>}
            <AddFunnelIcon onClick={() => { setAddNewFunnel(true); setEditFunnel(false), setselectedFunnel(undefined) }} />
          </div>

          <div className='scrollable-div' ref={scrollRef}
            onScroll={handleScroll}>
            {useGetFunnelMutation.isLoading && (
              <div className="h-full w-full flex items-center justify-center  ">
                <Lottie className="loading-loader-class" animationData={noDataAnimation} />
              </div>
            )}
            {actualList && actualList.length > 0 ? actualList.map((item: Funnel) => {

              return (<FunnelList funnelData={item} selectedFunnel={selectedFunnel} onSelectingFunnel={(id: any) => { getFunnelDetails(id) }} isArchivedFunnel={isArchivedFunnels} archivedFunnels={archivedFunnelIds} addToArchive={addToArchive} />)

            }) : (<div className='no-data-found item-alignment'>No Data!</div>)}
          </div>
        </div>

        {isArchivedConfirmation && <DeleteConfirmation archivedUsersList={archivedUsersList} open={isArchivedConfirmation} onClose={onClose} onConfirm={(data?:any)=>onConfirm(data)} message='Are you sure you want to archive these funnel ?' subText='Archive Funnels' />}

        {!isEditFunnel && !addNewFunnel && <FunnelView productList={productList} usersListData={usersList} isLoading={useGetFunnelDetailsMutation?.isLoading} selectedFunnel={selectedFunnel} onEditClick={() => { setEditFunnel(true) }} onClickArchiveFunnel={(data: any) => { onClickArchiveFunnel(data) }} />}
        {isEditFunnel && !addNewFunnel && <EditFunnel productList={productList} selectedFunnel={selectedFunnel} onEditClick={() => { setEditFunnel(false) }} onUpdateComplete={(id: any) => { setEditFunnel(false), getFunnelDetails(id), getFunnelstList(1, true, '', id), getTotalDeals() }} />}
        {addNewFunnel && <AddFunnel productList={productList} usersListData={usersList} onEditClick={() => { setAddNewFunnel(false); getFunnelstList(1, true, '') }} onUpdateComplete={(id: any) => { setAddNewFunnel(false), getFunnelstList(1, true, ''), getTotalDeals(), setSelectedTab(0) }} />}
        {funneltList && funneltList.length > 0 && <HistoryView productList={productList} usersListData={usersList} addNewFunnel={addNewFunnel} selectedFunnel={selectedFunnel} />}
      </div>

    </>
  );
};
